// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar--NUq57tQPDc","light":"light--tsWyh-QhSE","dark":"dark--6AbVStcDf5","controls":"controls--c4co3UZUf1"};